// extracted by mini-css-extract-plugin
export default {"actions":"caEFKNDs9SK07J0o12ZC","header":"vHyr_UftxxtRsGkeqtt0","body":"vE06OuFeFPifU1FbHlOp","footer":"xhxpFfUpaAyVG1I83yFJ"};